// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__30fLP","errorLogs":"EditorFooter_errorLogs__3WIX1"};